<template>
  <div class="web-header">
    <div class="logo">
      <i class="iconfont iconcaidan" @click="updateCollapse"></i>
      <img src="@/assets/img/logo.jpg" alt="logo" />
    </div>
    <div class="user">
      <router-link class="menu-item" v-for="item of menuList" :key="item.text" :to="item.link">
        {{ item.text }}
      </router-link>
      <el-dropdown class="menu-item user-item" @command="handleCommand">
        <div class="el-dropdown-link">
          <img src="@/assets/img/user.png" class="img" alt="avatar" />
          <span>{{ userName }}</span
          ><i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="item.code" v-for="item of dropdownList" :key="item.code">
            {{ item.text }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'Header',
  data() {
    return {
      userName: '用户名',
      menuList: [
        {
          text: '首页',
          link: '/index',
        },
        {
          text: '帮助中心',
          link: '#',
        },
        {
          text: '消息中心',
          link: '#',
        },
      ],
      dropdownList: [
        {
          text: '创建应用',
          code: 'APPLY',
        },
        {
          text: '退出登录',
          code: 'SIGN_OUT',
        },
      ],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapMutations('main', ['updateCollapse']),

    // 初始化数据
    initData() {
      try {
        const loginInfo = JSON.parse(localStorage.getItem('loginUesr'));
        const {
          userInfo: { username = '用户名' },
        } = loginInfo;
        this.userName = username;
      } catch (error) {
        console.error(error);
      }
    },

    // 监听执行用户菜单项事件
    handleCommand(command) {
      switch (command) {
        case 'SIGN_OUT':
          this.handleSignOut();
          break;
        case 'APPLY':
          this.creatApply();
          break;
        default:
          break;
      }
    },

    // 退出登录
    handleSignOut() {
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },
    // 创建应用
    creatApply() {
      this.$router.push({ name: 'apply/index' });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';

.web-header {
  width: 1250px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.logo {
  .box_row_center();
  .iconfont {
    margin-left: 1em;
    margin-right: 0.7em;
    cursor: pointer;
  }
}
.user {
  display: flex;
  align-items: center;
  .menu-item {
    margin-right: 2em;
    text-decoration: none;
    color: @font-color-black;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
  .user-item > .el-dropdown-link {
    .box_row_center();
    .img {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      margin-right: 0.7em;
    }
  }
}
</style>
